import {React, observer, classNames, useAsObservableSource, useIntersectionObserver, useLayoutEffect, Fragment} from '@api'
import {DropTargetType, StoresInstance} from '@stores'
import {useVipLocalStore, VipLocalStore} from '@modules'
import {computed, observable} from 'mobx'
import {createGlobalStyle} from 'styled-components'
import * as css from './DragEventPlaceholders.css'
import {CircularProgress} from '@material-ui/core'
import {Check} from '@material-ui/icons'
import {Spinner} from '@blueprintjs/core'

interface MyProps {
  id: string
  dropType: DropTargetType
  className?: string
  hideLoader?: boolean
  hideSuccess?: boolean
}

class DragEventPlaceholdersStore extends VipLocalStore {
  constructor(stores: StoresInstance,public props: MyProps) {
    super(stores)
  }

  /**
   * Replaced with autorun to do one operation instead of N operations (one per drop placeholder)
   * We need to be very careful in this function to avoid having to recalculate EVERY drop placeholder on the screen whenever the user drags over a new item
   */

  /*
  @computed get showDropIndicator() {
    const {props: {id, dropType}} = this, {dragItem, allowDrop} = dragDrop
    // trace()
    console.log(`showDropIndicator?`, {id, dropType})
    let allowed = dragItem
           && dragItem.id != id
           && dragDrop.dragOverItem?.target == dropType

    if (!allowed) { // Can't drop on this type
      return false
    } // Valid and Dragged over us
      else {
      const {dragOverItem} = dragDrop
      if (dragOverItem.target == dropType && dragOverItem.id == id) {
        return allowDrop({id, target: dropType})
      } else if (dragOverItem.dragType == catalog.index) { // Over a valid target, is it part of the selection set and are we as well?
        // Is this a field assignment?  If so we can drop on selected object(s)
        if (catalog.catalogConfig.fields.some(f => dragItem.dragType == es.indexes.tag || f.esIndex == dragItem.dragType || f.showAsLibrary)) {
          const {selection: {selectedIds}} = catalog
          if (selectedIds.has(id) && selectedIds.has(dragOverItem.id)) {
            return allowDrop({id, target: dropType})
          }
        }
      }
    }

    return false
  }*/

  @computed get dragDropState() { return this.handler?.state }

  @computed get loading() {
    return this.dragDropState?.status === 'loading'
  }

  @computed get success() {
    return this.dragDropState?.status === 'success'
  }

  @computed get handler() {
    return this.dragDrop.ddHandlers.get(this.props.id)
  }

  @observable everVisible = false
  /**
   * Is there anything in this catalog that can be dropped on to this item?
   */
  @computed get isValidDropTarget() {
    const {dragDrop, props: {dropType, id}} = this
    return _.values(dragDrop.ddInteractions).some(v => v?.[dropType] != null)
  }

  @computed get parsedId() {
    return this.catalog.parseIdFromPath(this.props.id)
  }

  /*  Switched directly to document.querySelectorAll for performance reasons
  @computed get showDropIndicator() {
    const r = dragDrop.dropPlaceholders.has(this.props.id) || dragDrop.dropPlaceholders.has(this.parsedId)

    return r
  }
   */
}

/* Attempting to speed things up by just changing a single style instead of computing for every placeholder - still slow
const StyledDropIndicatorStyles = createGlobalStyle<{ids: string[]}>`
  ${p => p.ids.map(id => `[data-type='DefaultDropPlaceholder'][data-id='${id}']`).join(',')} {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 5;
    top: 0;
    left: 0;
    align-items: center;
    justify-content: center;
    display: flex;
    opacity: 1;
    background: var(--selected-background-no-transparent);
  }
`

export const DropIndicatorStyles = observer(function DropIndicatorStyles() {
  return <StyledDropIndicatorStyles ids={Array.from(dragDrop.dropPlaceholders.values())} />
})
*/

export const DragEventPlaceholders = observer<MyProps>(function DragEventPlaceholders({children, ...props}) {
    const obsProps = useAsObservableSource(props),
      store = useVipLocalStore((ws) => new DragEventPlaceholdersStore(ws, obsProps)),
      {isValidDropTarget, success, handler, everVisible, dragDrop: {dragItem, isDragging}} = store,
      {className, hideLoader, hideSuccess} = props,
      isDragOver = handler?.showDropIndicator === true

    useLayoutEffect(() => {
      store.everVisible = everVisible || isDragOver
    }, [!everVisible && isDragOver])

  if (!everVisible || !dragItem || dragItem?.id === props.id || !isValidDropTarget) {
    //console.debug('Invalid drop target - Why are you creating this DragEventPlaceholders?', props.id, props.dropType)
    return null
  }

   // console.log(`render DragEventPlaceholders DOM`, {id: props.id})

  // Todo - make this only render if visible
    return !everVisible ? null : <Fragment>
        <div className={classNames(className, css.dropIndicator)}
            data-placeholder-drag-over={isDragOver} // directly modify with query selector for performance
            data-is-allowed={!isDragging ? undefined : handler?.isDropAllowed === true}
            data-type='DefaultDropPlaceholder'
            data-id={props.id}
            data-catalog-id={store.parsedId} // id without group info, product cards might exist in multiple groups at once
            data-drop-type={props.dropType}
            data-loading={store.loading}
            data-success={success}
      >
        {/*<Add className={css.add_icon} />*/}
          {children}
      </div>

      {!hideLoader && store.loading && <div
		  className={classNames(className, css.loadingIndicator)}
		  data-placeholder-drop-here={true}
	  >
		  <Spinner intent='primary' size={30}/>
	  </div>}

      {!hideSuccess && success && <div data-placeholder-success={success}
	                                   className={classNames(css.successIndicator, className)}>
		  <Check className={css.success_icon}/>
	  </div>}
    </Fragment>
  })
/*
DragEventPlaceholders.defaultProps = {
  hideLoader: true,
  hideSuccess: true
}*/



// WEBPACK FOOTER //
// ./src/shared/components/ui/widgets/DragEventPlaceholders.tsx